// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordianBody_root__0vJKf","dark":"AccordianBody_dark__Kwi2K","light":"AccordianBody_light__W_pTc","body":"AccordianBody_body__bGqpm"};